import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import ccsStyles from './chyron.module.css';
import useStyles from './styles/Chryron.styles';

/**
 * A configurable chyron for react
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const Chyron = (props) => {
    const { snippets, speed, color, size, uppercase } = props;

    const { classes } = useStyles();
    const width = window.innerWidth;
    const snipJoin = snippets.join();
    const characterLength = snipJoin.length;
    let msAmount = speed ? speed : Math.max(20000, characterLength * (width / 2));

    const rootStyle = {};
    if (color) {
        rootStyle.backgroundColor = color;
    }

    let rootClass = classes.tickerWrap;
    let tickerClass = ccsStyles.ticker;

    if (size === 'small') {
        rootClass += ` ${classes.heightSmall}`;
        tickerClass += ` ${classes.heightSmall} ${classes.fontSmall}`;
    }

    if (size === 'medium') {
        rootClass += ` ${classes.heightMedium}`;
        tickerClass += ` ${classes.heightMedium} ${classes.fontMedium}`;
    }

    let textClass = classes.stickerItem;
    if (uppercase) {
        textClass += ` ${classes.uppercase}`;
    }

    return (
        <div className={rootClass} style={rootStyle}>
            <div className={tickerClass} style={{ animation: `${ccsStyles.ticker} ${msAmount}ms linear infinite` }}>
                {snippets.map((snippet, idx) => {
                    return (
                        <Typography key={`chyron-${idx}`} className={textClass}>
                            {snippet}&nbsp;&nbsp;&nbsp;
                        </Typography>
                    );
                })}
            </div>
        </div>
    );
};

Chyron.propTypes = {
    snippets: PropTypes.array,
    speed: PropTypes.number,
    color: PropTypes.string,
    size: PropTypes.oneOf(['small', 'medium']),
    uppercase: PropTypes.bool,
};

export default Chyron;
